import type { FC } from "react";

import { WWOTopAdDestinationsTable } from "app/pages/website-performance/components/TopAdDestinations/WWOTopAdDestinationsTable";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOTopAdDestinationsContainerDS: FC = () => {
    const params = proNavigator.getParams();

    const getCtaLink = () => {
        return {
            href: proNavigator.href("digitalsuite_website_publisher_overview", params),
            target: "_self",
        };
    };
    return <WWOTopAdDestinationsTable getCtaLink={getCtaLink} />;
};
